module.exports = __webpack_public_path__ + "assets/img/11942dcbb101d17ec3eab5de1c825249.svg";